export async function delay(timeout: number = 0) {
    await new Promise((resolve) => setTimeout(resolve, timeout))
}

export async function retryOnError<ResultType>(func: () => Promise<ResultType>, retries: number = 5, timeoutMs: number = 500, maxTimeoutMs: number = timeoutMs * 4): Promise<ResultType> {
    async function retryLoop(currentTry: number): Promise<ResultType> {
        try {
            return await func()
        } catch(e) {
            if(currentTry >= retries) throw e

            await delay(Math.min(currentTry * timeoutMs, maxTimeoutMs))

            return retryLoop(currentTry + 1)
        }
    }

    return retryLoop(1)
}
